import * as React from 'react';
import classnames from 'classnames';

import { HaldiButton } from '@src/routes/common/components/HaldiButton';

export interface SurveyButtonProps {
  className?: string;
  cta?: string;
  current: number;
  total: number;
}

/**
 * @name SurveyButton
 * @description A generic button that we use to navigate forwards and back
 * through the survey questions
 */
export const SurveyButton = (props: SurveyButtonProps) => {
  const { className, cta = 'Next', current, total } = props;

  // Setup
  const isSubmit = current === total;
  const text = isSubmit ? 'Submit Survey' : cta;
  const cssBtn = classnames(className, { 'bg-white': isSubmit });

  return (
    <HaldiButton className={cssBtn} bordersX="rust" thick={true} type="submit">
      {text}
    </HaldiButton>
  );
};
